import { img7 } from "../../_components/Imagepath";

export default {
    Data: [
        {
            id:6,  
            key:6,
            Invoice: "#4992",
            Category: "Stationary",
            Created : "16 Nov 2022",
            Name: "Randall ",
            email: "randall@example.com",
            img:img7,
            Total: "$5,54,220",
            Paid: "$6,50,000",
            Payment: "Cash",
            Balance: "$4,220",
            Due: "25 Feb 2023",
            Status: "Refunded",
            Action: ""
          }
    ]
}